class KaKaoLoginManager {
    #isKaKaoInstalled;

    setKaKaoInstalled(flag){
        this.#isKaKaoInstalled = flag
    }

    async getKaKaoInstalled(){
        /*eslint-disable no-undef */
        webkit.messageHandlers.ios.postMessage({cmd : 'checkKaKaoInstalled'});
        await this.#waitMiliSeconds(100);
        return this.#isKaKaoInstalled;
    }

    #waitMiliSeconds(time) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }
}

const instance = new KaKaoLoginManager();

export default instance;